define(
	'app/ui/modal/age-gate',[
		'jquery',
		'jquery.cookie',
		'pubsub'
	],

	function ($, moment) {
		'use strict';

		var $ageGate;
		
		var selectors = {
			submit: '.js-age-gate__submit',
			decline: '.js-age-gate__decline',
			error: '.js-age-gate__error'
		};
		
		var module = {
			init: function ($elm) {
				$ageGate = $elm;

				module._initEvents();
			},

			_initEvents: function () {
				$ageGate.on('click', selectors.submit, module._ageGateSubmit);
				$ageGate.on('click', selectors.decline, module._ageGateDecline);
			},
			
			// prevent default submission
			// if valid age close modal
			// if not show error message
			_ageGateSubmit: function (event) {
				event.preventDefault();
				module._closeModal();
			},

			// prevent default submission
			// show error message
			_ageGateDecline: function(event) {
				event.preventDefault();
				module._displayError();
			},

			// close modal
			//set cookie
			_closeModal: function () {
				$ageGate.closest('.js-modal').empty().remove();
				$.cookie('ageVerified', true, { expires: 30, path: '/' });
			},

			// display error message
			_displayError: function () {
				$(selectors.error).attr('aria-hidden', false);
			}
		};

		return {
			init: module.init
		};

	}
);

